<template>
  <div class="main-content-container contact-info-container">
    <div class="top-content-container normalize-zIndex position-relative">
      <b-row>
        <b-col class="position-relative breadcrumbs-column" md="6" cols="12">
          <b-breadcrumb>
            <b-breadcrumb-item>
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span
                v-if="paFullname.length > 0"
                class="text-uppercase font-family-medium"
              >
                {{ paFullname }}
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>

        <b-col
          v-if="!showSkeletonLoader"
          md="12"
          cols="12"
          class="pa-avatar-column d-none d-md-flex d-lg-flex d-xl-flex justify-content-end position-relative"
        >
          <div class="user-info-right d-flex mr-4">
            <b-avatar
              size="8rem"
              v-if="userAvatar"
              :src="userAvatar"
            ></b-avatar>
            <b-avatar
              size="8rem"
              v-else
              :text="userInitials"
              class="bg--primary"
            ></b-avatar>
            <div class="user-info-content">
              <p class="font-family-medium primary--text pa-name">
                {{ paFullname }}
              </p>
              <p v-if="role === 'admin' && !isViewedOwner" class="secondary--text">
                {{ workHours }} hours/week
              </p>
            </div>
          </div>
        </b-col>
        <b-col
          v-else
          md="12"
          cols="12"
          class="pa-avatar-column skeleton-column d-none d-md-flex d-lg-flex d-xl-flex justify-content-end position-relative"
        >
          <div class="user-info-right d-flex">
            <b-skeleton type="avatar" size="8rem"></b-skeleton>
          </div>
          <div
            class="user-info-content d-flex flex-column justify-content-center position-relative"
          >
            <b-skeleton width="14rem"></b-skeleton>
            <b-skeleton width="14rem" class="mt-3"></b-skeleton>
          </div>
        </b-col>

        <b-col class="d-xl-none d-md-none d-lg-none" md="12" cols="12">
          <div class="user-info-right d-flex justify-content-start">
            <b-avatar
              size="8rem"
              v-if="userAvatar"
              :src="userAvatar"
            ></b-avatar>
            <b-avatar
              size="8rem"
              v-else
              :text="userInitials"
              class="bg--primary"
            ></b-avatar>
            <div
              class="user-info-content d-flex flex-column position-relative"
              :class="[role === 'assistant' ? 'justify-content-center' : null]"
            >
              <h4 class="font-md font-family-medium primary--text">
                {{ paFullname }}
              </h4>
              <p v-if="role === 'admin' && !isViewedOwner" class="secondary--text">
                {{ workHours }} hours/week
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-tabs
      v-model="tabIndex"
      @input="setActiveTab"
      v-if="!isLoadingTabs"
      class="mt-4"
      style="height:85%"
      active-nav-item-class="danger"
      active-tab-class="text-success"
    >
      <b-tab style="height:100%" title="Tasks" v-if="showTasksTab">
        <PATasks v-if="tabIndex == 0" />
      </b-tab>
      <!-- <b-tab title="Professional Goal" v-if="role === 'admin' || isSelf">
        <PAProfessionalGoals />
      </b-tab> -->
      <b-tab title="Contacts">
        <PAContactInfo :tab="tabIndex" :isSelf="isSelf" />
      </b-tab>
      <b-tab title="Customers" class="mb-5" v-if="showCustomersTab">
        <PACustomers v-if="tabIndex === customersTabIndex" />
      </b-tab>
    </b-tabs>
    <b-avatar
      v-if="role === 'admin' && tabIndex === customersTabIndex"
      button
      @click="$router.push({ name: 'AddCustomer' })"
      size="4.8rem"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
  </div>
</template>

<script>
import PATasks from "../common/assistant/tasks/PATasks";
// import PAProfessionalGoals from "../common/assistant/professional/PAProfessionalGoals";
import PACustomers from "../common/assistant/customers/PACustomers";
import PAContactInfo from "../common/assistant/contact-info/PAContactInfo";
import { getProfile } from "@/apis/auth";
import { getAssistantDetails } from "@/apis/assistants";

export default {
  name: "PADetails",
  components: {
    PATasks,
    // PAProfessionalGoals,
    PACustomers,
    PAContactInfo
  },
  data() {
    return {
      workHours: "",
      isLoadingTabs: true,
      isLoadingCustomers: true,
      showSkeletonLoader: true,
      tabIndex: null,
      userAvatar: null,
      userInitials: "",
      isSelf: null,
      paFullname: "",
      role: "",
      viewedProfileRole: null,
      resetForm: false,
      customersList: []
    };
  },
  computed: {
    // The profile being viewed — not the logged-in user.
    isViewedOwner() {
      return this.viewedProfileRole === "owner";
    },
    // Owner accounts never have a task board — Customers stays visible.
    showTasksTab() {
      if (this.isViewedOwner) return false;
      return this.role === "admin" || this.isSelf;
    },
    showCustomersTab() {
      return this.role === "admin" || this.isSelf;
    },
    // Without Tasks, Customers is index 1 for Owner profiles (else 2).
    customersTabIndex() {
      return this.isViewedOwner ? 1 : 2;
    }
  },
  methods: {
    resolveViewedProfileRole(details) {
      if (details?.role?.name) return details.role.name;
      if (details?.profile?.role?.name) return details.profile.role.name;
      if (details?.profile?.jobTitle === "OWNER") return "owner";
      return "assistant";
    },
    setActiveTab() {
      this.$router.push({
        params: {
          uuid: this.$route.params.uuid
        },
        name: "PADetails",
        query: {
          tab: this.tabIndex
        }
      });
      this.resetForm = true;
    },
    // Owner profiles skip Tasks — only remap legacy tab=2 (Customers on EA layout).
    normalizeTabForViewedProfile(initialTab) {
      if (!this.isViewedOwner || initialTab !== 2) return;
      this.tabIndex = 1;
      this.$router.replace({
        name: "PADetails",
        params: { uuid: this.$route.params.uuid },
        query: { tab: 1 }
      });
    }
  },
  created() {
    const initialTab = Number(this.$route.query.tab) || 0;
    this.tabIndex = initialTab;
    const profilePromise = getProfile()
      .then(res => {
        const role = res.data.role;
        this.role = typeof role === "string" ? role : role?.name;
        if (this.$route.params.uuid === res.data.defaultProfile.id) {
          this.isSelf = true;
        }
      })
      .catch(err => {
        console.log(err);
      });
    const detailsPromise = getAssistantDetails(this.$route.params.uuid)
      .then(res => {
        let { user, profile } = res.data;
        this.viewedProfileRole = this.resolveViewedProfileRole(res.data);
        this.workHours = Number(profile.workHours) || "N/A";
        this.paFullname = `${user.firstName} ${user.lastName} `;
        this.userAvatar = user.avatarThumbnail || user.avatar || null;
        this.userInitials = this.paFullname.match(/\b(\w)/g).join("");
      })
      .catch(err => {
        console.log(err);
        this.showSkeletonLoader = false;
      })
      .finally(() => {
        this.showSkeletonLoader = false;
      });
    Promise.all([profilePromise, detailsPromise]).finally(() => {
      this.normalizeTabForViewedProfile(initialTab);
      this.isLoadingTabs = false;
    });
  },
  watch: {
    $route(to) {
      if (to.query && to.query.tab) {
        this.tabIndex = Number(to.query.tab);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.floating-action-btn {
  right: 3rem;
  bottom: 0;
  z-index: 2;
}
.skeleton-column {
  margin-left: -2rem;
}
.user-info-right {
  right: 0;
  top: -10%;
  right: 2%;
}
.user-info-content {
  flex-direction: column;
  display: flex;
  padding-left: 10px;
  > p {
    flex: 1;
    margin-bottom: 0;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  > p:only-child.pa-name {
    align-items: center;
  }
  > p:nth-child(1) {
    align-items: flex-end;
  }
  > p:nth-child(2) {
    align-items: flex-start;
  }
}
.general-info-card {
  padding: 1rem;
}
.notification-btn-list-container {
  margin: 2rem 0 2rem auto;
}
.breadcrumbs-column {
  z-index: 1000;
}
.pa-avatar-column {
  margin-bottom: -5rem;
  bottom: 3rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
</style>
